import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/imgs/about_banner_pc.png'
import _imports_1 from '../assets/imgs/about_banner_mobile.png'


const _hoisted_1 = { id: "about" }
const _hoisted_2 = { id: "banner" }
const _hoisted_3 = { class: "banner" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "hide-mobile banner__bg"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "hide-md banner__bg"
}, null, -1)
const _hoisted_6 = {
  id: "core_team",
  class: "core_team"
}
const _hoisted_7 = { class: "core_team" }
const _hoisted_8 = { class: "core_team__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CardMini = _resolveComponent("CardMini")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("section", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", {
          class: "banner__title",
          innerHTML: _ctx.text.banner.title,
          "data-aos": "fade-up"
        }, null, 8, ["innerHTML"]),
        _createVNode("div", {
          class: "banner__detail",
          innerHTML: _ctx.text.banner.detail
        }, null, 8, ["innerHTML"])
      ]),
      _hoisted_4,
      _hoisted_5
    ]),
    _createVNode("section", _hoisted_6, [
      _createVNode("div", _hoisted_7, [
        _createVNode("div", {
          class: "core_team__title",
          innerHTML: _ctx.text.core_team.title
        }, null, 8, ["innerHTML"]),
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_CardMini, {
            title: _ctx.text.core_team.founderTeam,
            icon: "co-broking",
            iconRounded: "full",
            iconAlign: "left",
            color: "#E4EDFF",
            iconColor: "#3F7DF4"
          }, null, 8, ["title"]),
          _createVNode(_component_CardMini, {
            title: _ctx.text.core_team.marketingTeam,
            icon: "marketing",
            iconRounded: "full",
            iconAlign: "left",
            color: "#FFE4EC",
            iconColor: "#E27070"
          }, null, 8, ["title"]),
          _createVNode(_component_CardMini, {
            title: _ctx.text.core_team.businessDevelopment,
            icon: "building",
            iconRounded: "full",
            iconAlign: "left",
            color: "#EBE4FF",
            iconColor: "#8460EA"
          }, null, 8, ["title"]),
          _createVNode(_component_CardMini, {
            title: _ctx.text.core_team.operationTeam,
            icon: "operation-team",
            iconRounded: "full",
            iconAlign: "left",
            color: "#CCF0F3",
            iconColor: "#08909C"
          }, null, 8, ["title"]),
          _createVNode(_component_CardMini, {
            title: _ctx.text.core_team.technologyTeam,
            icon: "technology-team",
            iconRounded: "full",
            iconAlign: "left",
            color: "#ECECEC",
            iconColor: "#404040"
          }, null, 8, ["title"])
        ])
      ])
    ])
  ]))
}